<app-history-item
  *ngFor="let weather of favoriteservice.Favorite"
  [historyItem]="weather">
</app-history-item>
